<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <ContratSection />
  <RemunerationSection />
  <MobiliteSection />
</template>

<script setup lang="ts">
  import ContratSection from './sections/contrat/ContratSection.vue'
  import RemunerationSection from './sections/remuneration/RemunerationSection.vue'
  import MobiliteSection from './sections/mobilite/MobiliteSection.vue'
</script>
